import { useCallback, useState } from 'react'
import { useSpacesApi } from '../../../spaces-api'
import { downloadBlob } from '../../../utils'
import { Axios, AxiosInstance } from 'axios'

interface UseDownloadFormSubmissionsProps {
  formNodeId: string
  submissionIds?: string[]
}

export async function downloadForm(
  api: AxiosInstance | Axios,
  formNodeId: string,
  submissionIds?: string[],
) {
  const url = submissionIds?.length
    ? `/forms/${formNodeId}/download?submissionIds=${submissionIds.join(',')}`
    : `/forms/${formNodeId}/download`

  const response = await api.get(url, {
    responseType: 'blob',
  })

  // Get filename from Content-Disposition header
  const contentDisposition = response.headers?.['content-disposition']
  const filename = contentDisposition?.split('filename=')[1]?.replace(/"/g, '') || 'form-responses'
  downloadBlob(response.data, filename)
}

export function useDownloadFormSubmissions({
  formNodeId,
  submissionIds,
}: UseDownloadFormSubmissionsProps) {
  const { spacesApi } = useSpacesApi()
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = useCallback(async () => {
    if (isDownloading) return

    try {
      setIsDownloading(true)
      await downloadForm(spacesApi, formNodeId, submissionIds)
    } catch (error) {
      console.error('Failed to download form submissions:', error)
      throw error
    } finally {
      setIsDownloading(false)
    }
  }, [formNodeId, submissionIds, spacesApi, isDownloading])

  return {
    isDownloading,
    handleDownload,
  }
}
